import { IUserData } from "api/auth";
import {
  ICustomQuestionParams,
  ISupportedChain,
  IInfraDeploy,
} from "api/hackathon";

export interface ICreateProjectParams {
  name: string;
}

export interface IAddTeamMember {
  projectId: string;
  guestId: string;
}
export interface IUpdateProjectParams {
  name: string;
  tagLine: string;
  description: string;
  technology: string[];
  linkDemo: string;
  category: string;
  linkVideoDemo: string;
  thumbnailImage: string;
  team_information: string;
  twitter_url: string;
  github_url: string;
  team_description: string;
  infrastructure_deployeds: string[];
  supported_chains: string[];
  team_members: string[];
}

export interface ICreateCommentParams {
  message: string;
  topicId?: string;
}
export interface IUpdateCommentParams {
  _id: string;
  message: string;
}

export interface IComment {
  _id: string;
  flags: any[];
  message: string;
  projectId: string;
  typeUpdateProject: boolean;
  userId: IUserData;
  createdAt: Date;
  updatedAt: Date;
}

export interface IProjectSubmission {
  _id: string;
  name?: string;
  thumbnailImage?: string;
  sub_status?: string;
  submit_late: boolean;
  winner?: string;
  essentials?: {
    url?: string;
  };
  status_inprogess: "draft" | "submit" | "pending";
  submission: {
    startDate: number;
    deadline: number;
  };
  judging: {
    judgingType: "online" | "offline";
    judgingDate: {
      startDate: number;
      endDate: number;
    };
  };
  vote: {
    startVote?: number;
    endVote?: number;
  };
  url?: string;
  announce_winner: number;
  timeZone: string;
  voted_project: boolean;
}
export interface IProject {
  _id: string;
  comments: IComment[];
  winner?: string[];
  length: 0;
  createdAt: string;
  description: string;
  imageGallerys: IGallery[];
  likes: {
    _id: string;
    firstName: string;
    lastName: string;
    userName: string;
    avatar_link: string;
  }[];
  topics: any;
  name: string;
  projectOwner: IUserData;
  status: "draft" | "done";
  tagLine: string;
  technology: string[];
  thumbnailImage: string;
  updatedAt: string;
  linkDemo: string[];
  linkVideoDemo: string;
  isStar: boolean;
  isHidden: boolean;
  describe: string;
  sub_status: string;
  status_inprogess: "draft" | "submit" | "pending";
  hackathonIds: IProjectSubmission[];
  onSubmission: boolean;
  category: any;
  categories: string[];
  childTag: string;
  submission_project?: {
    fileUpload?: string;
    customFormQuestion: ICustomQuestionParams[];
  };
  teammateOwners: IUserData[];
  secret_invite_code: string;
  skipTeammate: boolean;

  countViews: number;
  hackathon_status: "Upcoming" | "ended" | "open" | "";
  supported_chains: ISupportedChain[];
  infrastructure_deployeds: IInfraDeploy[];
  team_description: string;
  github_url: string;
  twitter_url: string;
  team_information: string;
  demo_version_name: string;
  videoThumbnailUrl: string;
}
export interface IGallery {
  _id: string;
  imageUrl: string;
  caption: string;
}
export interface ISupportedChains {
  _id: string;
  name: string;
  __v: number;
}

export interface IInfrastructureDeployeds {
  _id: string;
  name: string;
  __v: number;
}
export interface IProjectInProgress {
  _id: string;
  status_inprogess: "draft" | "submit" | "pending";
  projectId: IProject;
}

export interface IUserProject {
  projectInProgess: IProject[];
  projectPortfolio: IProject[];
}

export interface IUpdateProjectOverview {
  name: string;
  tagLine: string;
  thumbnailImage: string;
}
export interface IUpdateProjectDetail {
  description: string;
  technology: string[];
  linkDemo: string;
  linkVideoDemo: string;
}
export interface IDeleteSubmissionParams {
  hackathonId: string;
  projectId: string;
  projectOwner: string;
  visibleStatus?: string;
}

export interface IUpdateProjectTopicParams {
  _id: string;
  message: string;
}
export interface IUpdateProjectAdditional {
  fileUpload?: string;
  customFormQuestion: ICustomQuestionParams[];
}

export interface ICreateProjectTopicParams {
  projectId: string;
  message: string;
  topic_type: "project";
  project_type: "started" | "posted";
}
export interface IProjectTopic {
  _id: string;
  comments: IComment[];
  createdAt: string;
  message: string;
  projectId: string;
  project_type: "posted" | "started";
  topic_type: "project";
  updatedAt: string;
  userId: IUserData;
}
export interface IUpdateProjectDecribeParams {
  projectId: string;
  describe: string;
}

export const LIST_SOFTWARE_PAGE_SIZE = 24;

export interface IListSoftwarePayload {
  search?: string;
  sort_type?: "newest" | "popular" | "trending";
  filter_type?:
    | "my_project"
    | "friend_project"
    | "winner"
    | "demo_video"
    | "category";
  childTag?: string[];
  page?: number;
  pageSize?: number;
}

export interface IInfinitySoftwarePayload {
  search?: string;
  sort_type?: "newest" | "popular" | "trending";
  filter_type?:
    | "my_project"
    | "friend_project"
    | "winner"
    | "demo_video"
    | "category";
  childTag?: string[];
  filter_categories?: any;
  page?: number;
  pageSize?: number;
}

export interface IListSoftware {
  pagedResult: {
    items: IProject[];
    page: number;
    pageSize: number;
    totalItems: number;
  };
}
export interface IListSoftwareBase {
  project_your_friends: IProject[];
  popular_projects: IProject[];
  trending_tags: { _id: string; name: string; count: number }[];
}

export interface IInfinitySoftware {
  trending_tags: {
    _id: string;
    name: string;
    __v: number;
    totals: number;
  }[];
  categories: {
    _id: string;
    name: string;
    totals: number;
  }[];
  projects: {
    pagedResult: {
      items: IProject[];
      page: number;
      pageSize: number;
      totalItems: number;
    };
  };
}

export interface IUpdateTeammatePayload {
  projectId: string;
  hackathonId: string;
  guestId: string;
}

export interface IUpdateTeammemberPayload {
  projectId: string;
  guestId: string;
}

export interface ISecretTeammatePayload {
  secret_code: string;
}

export interface IRequestTeamUpParams {
  hackathonId: string;
  request_to_userId: string;
  message: string;
}

export interface ISkipTeammatePayload {
  projectId: string;
}

export interface ICreateProjectReview {
  star: number;
  wells: string[];
  improves: string[];
  experience: string;
  currentUser: number;
  hackathonId?: string;
  projectId: string;
}

export interface IProjectReview {
  wells: string[];
  improves: string[];
  _id: string;
  star: number;
  experience: string;
  currentUser: number;
  projectId: string;
  userId: IUserData;
  createdAt: string;
  updatedAt: string;
}

export interface IRelativeProject {
  projectsTrendingTag: IProject[];
  projectsRelative: IProject[];
}
